module.exports = "./img/be7fb5c5e7b64f5a8d5117bfda1116cf.jpg";